export interface Version {
    ClientKey?: string;
    Id: string;
    VersionName: string;
    Disclaimer?: string;
}